import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=47b8a752&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=47b8a752&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b8a752",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Reports/InventoryLog/Index.vue
// module id = 2224
// module chunks = 31